import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-135" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-136" data-mp="1mo2182j7gpfa">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-137" data-mp="1mmqz075erpqa">
          <span aria-hidden="true" data-id="element-138" data-mp="tyv5tcf1sfy9">🏆 </span>Offerta Speciale di Lancio
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-139" data-mp="u0xunt4gs31e">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-140" data-mp="13x15dnddt9zy">
            YOGA PRONTA™ Pack
          </span>

          <dl data-id="element-141" data-mp="2fbogw95pjkii">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-142" data-mp="2fad3riqdh0eq">
                <dt className="text-ink/80" data-id="element-143" data-mp="pj5v4pirqkej">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-144" data-mp="uj1weh02zxqe">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-145" data-mp="zioa0rjtnfzq">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-146" data-mp="13jqa1alkbw2r">Valore Totale:</dt>
              <dd className="font-bold text-amber-600 line-through" data-id="element-147" data-mp="6tpmtg0udnnk">€129</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-148" data-mp="bskfrasiwsle">
            Solo per oggi
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-149" data-mp="fsukkk4kxcyo">
            <span className="text-4xl leading-none" aria-hidden="true" data-id="element-150" data-mp="kmp7dwfhe81z">
              🏆
            </span>
            <span className="font-display text-6xl font-black leading-none text-brand" data-id="element-151" data-mp="3k8dp95oft3sy">€19</span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-ink/60" data-id="element-152" data-mp="3o84o7wo4aq8k">
            <span aria-hidden="true" data-id="element-153" data-mp="vdnw4n0brz8p">💳 </span>Pagamento unico, accesso a vita. Nessun abbonamento.
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-154" data-mp="155k891z8xpvx" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-155" data-mp="154imo3kltkzy">
            Download Istantaneo · Pagamento Unico · Accesso a Vita · Garanzia di 7 Giorni
          </p>
        </div>
      </div>
    </section>;
}